import { Controller } from "@hotwired/stimulus"
import { ComponentType, createElement } from "react"
import { createRoot, Root } from "react-dom/client"

const modules = import.meta.glob<{ default: ComponentType<Record<string, unknown>> }>(
  "../components/**/*.tsx",
  { eager: true }
)

const components: Record<string, ComponentType<Record<string, unknown>>> = {}
for (const [path, mod] of Object.entries(modules)) {
  const name = path.replace("../components/", "").replace(".tsx", "")
  components[name] = mod.default
}

export default class extends Controller {
  static values = { name: String, props: Object }

  declare nameValue: string
  declare propsValue: Record<string, unknown>

  private root!: Root

  connect() {
    const Component = components[this.nameValue]
    if (!Component) {
      console.warn(`[react] Unknown component: "${this.nameValue}". Available: ${Object.keys(components).join(", ")}`)
      return
    }
    this.root = createRoot(this.element)
    this.root.render(createElement(Component, this.propsValue))
  }

  disconnect() {
    this.root?.unmount()
  }
}
